module.exports = __webpack_public_path__ + "static/img/InformationPublish.5427a0b4.png";